export default {
  computed: {
    automationsRoutes() {
      return {
        "automations-vouxy": {
          title: "Vouxy"
        },

        "automations-hotzapp": {
          title: "Hotzapp"
        },

        "automations-telegram": {
          title: "Telegram"
        },

        "automations-make": {
          title: "Make"
        },

        "automations-zapier": {
          title: "Zapier"
        },

        "automations-clicksign": {
          title: "ClickSign"
        },

        "automations-funnel-control": {
          title: "Funnel Control"
        },

        "automations-digital-manager-guru": {
          title: "Digital Manager Guru"
        }
      }
    }
  }
}